import { Fragment, useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faCalendarDays, faClipboard, faDatabase, faDiagramProject, faEnvelope, faGear, faListCheck, faRepeat, faUsers } from '@fortawesome/free-solid-svg-icons';

import { useDispatch, useSelector } from 'react-redux';
import { updateTaskR as updateTaskRMenu, updateTask as updateTaskMenu, updateTaskOverdue as updateTaskOverdueMenu, updateTaskROverdue as updateTaskROverdueMenu, setMenuMainMobileShow, updateBoard as updateBoardMenu, updateBoardOverdue as updateBoardOverdueMenu } from '../../reducers/models/menuData';
import "./VerticalNavWrapper.css"
import useOutsideClick from '../../util/useOutsideClick';

function VerticalNavWrapper(props) {

    const [menuParamOpen, setMenuParamOpen] = useState(false);
    const [menuTaskRopen, setMenuTaskRopen] = useState(false);
    const [idRole, setIdRole] = useState(2);//По умолчанию "Пользователь"

    useEffect(() => {
        const url_mass = window.location.pathname.split('/');

        if (url_mass[2] === 'taskR') {
            setMenuTaskRopen(true);
        }
        if (url_mass[2] === 'param') {
            setMenuParamOpen(true);
        }
    }, []);

    function handlerClickMenu() {
        dispatch(setMenuMainMobileShow({ data: false }));
    }

    const dispatch = useDispatch()

    const stateMenuData = useSelector((state) => state.menuData);
    const stateSetting = useSelector((state) => state.setting);
    const stateTaskRTrackerList = useSelector((state) => state.taskRTrackerList);
    const stateTaskList = useSelector((state) => state.taskList);
    const stateBoardList = useSelector((state) => state.boardList);
    const stateBoardTaskList = useSelector((state) => state.boardTaskList);
    const stateCompanyList = useSelector((state) => state.companyList);//Информация о компаниях
    const stateTicket = useSelector((state) => state.ticket);

    //Обновление счетчика меню задач
    useEffect(() => {
        const currentDate = new Date();
        dispatch(updateTaskMenu({ data: stateTaskList.list.filter(a => a.Viewed === false & (a.id_tab === 1 || a.id_tab === 2)).length }))
        dispatch(updateTaskOverdueMenu({ data: stateTaskList.list.filter(a => (a.id_tab === 1 || a.id_tab === 2) & a.Date_End != null).filter(a => new Date(a.Date_End) < currentDate).length }))
    }, [stateTaskList.list]);

    //Обновление счетчика меню регулярных задач
    useEffect(() => {
        const currentDate = new Date();
        dispatch(updateTaskRMenu({ data: stateTaskRTrackerList.list.filter(a => a.Viewed === false & (a.id_tab === 0 || a.id_tab === 1)).length }))
        dispatch(updateTaskROverdueMenu({ data: stateTaskRTrackerList.list.filter(a => (a.id_tab === 0 || a.id_tab === 1) & a.Date_Finish != null).filter(a => new Date(a.Date_Finish) < currentDate).length }))
    }, [stateTaskRTrackerList.list]);

    //Обновление счетчика меню досок
    useEffect(() => {
        const currentDate = new Date();

        dispatch(updateBoardMenu({ data: stateBoardTaskList.list.filter(a => a.Viewed === false & a.ID_Responsible === stateSetting.user.ID).length }));

        var overdue = 0;

        stateBoardTaskList.list.filter(a => new Date(a.Date_End) < currentDate & a.Date_End !== null).map(item => {
            if (stateBoardList.list.filter(a => a.ID === item.ID_Board & a.ID_Type !== 3).length > 0) {
                //if (stateBoardList.list.filter(a => a.ID === item.ID_Board)[0].ID_Type !== 3) {
                overdue = overdue + 1;
                // }
            }

        })

        dispatch(updateBoardOverdueMenu({ data: overdue }));

    }, [stateBoardTaskList.list, stateBoardList.list]);

    //Обновляем настройки
    useEffect(() => {
        if (stateSetting.companyService !== null) {
            setIdRole(stateSetting.companyService.ID_Role);
        }
    }, [stateSetting]);


    const outsideClick = useOutsideClick(() => {
        dispatch(setMenuMainMobileShow({ data: false }));
    });

    return (
        <Fragment>
            <h5 className="app-sidebar__heading">Меню трекера</h5>
            <div className="metismenu vertical-nav-menu" ref={outsideClick}>
                <ul className="metismenu-container">
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="calendar" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faCalendarDays} />
                            </i>
                            Календарь
                        </NavLink>
                    </li>
                    {idRole !== 2 && (
                        <li className="metismenu-item">
                            <NavLink className="metismenu-link" to="project" onClick={() => handlerClickMenu()}>
                                <i className="metismenu-icon">
                                    <FontAwesomeIcon icon={faDiagramProject} />
                                </i>
                                Проекты
                            </NavLink>
                        </li>
                    )}
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="task" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faListCheck} />
                            </i>
                            Задачи
                            {stateMenuData.task > 0 && <span className="badge badge-menu badge-dot warning"> </span>}
                            {stateMenuData.taskOverdue > 0 && <span className="badge badge-menu badge-dot danger"> </span>}
                        </NavLink>
                    </li>
                    <li className="metismenu-item">
                        <a className="metismenu-link has-active-child" href="#" onClick={() => setMenuTaskRopen(!menuTaskRopen)}>
                            <i className="metismenu-icon"><FontAwesomeIcon icon={faRepeat} /></i>
                            Переодич. задачи
                            {stateMenuData.taskR > 0 && <span className="badge badge-menu badge-dot warning"> </span>}
                            {stateMenuData.taskROverdue > 0 && <span className="badge badge-menu badge-dot danger"> </span>}
                            <i className="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                        </a>
                        <ul className={menuTaskRopen === true ? "metismenu-container visible" : "metismenu-container"}>
                            <li className="metismenu-item">
                                <NavLink className="metismenu-link" to="/lk/taskR/current" onClick={() => handlerClickMenu()}>
                                    Текущие задачи {/*stateMenuData.taskR > 0 && <span className="badge badge-pill badge-success">{stateMenuData.taskR}</span>*/}
                                </NavLink>
                            </li>
                            <li className="metismenu-item">
                                <NavLink className="metismenu-link" to="/lk/taskR/setting" onClick={() => handlerClickMenu()}>
                                    Настройка
                                </NavLink>
                            </li>
                        </ul>
                    </li>
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="board" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faClipboard} />
                            </i>
                            Доски
                            {stateMenuData.board > 0 && <span className="badge badge-menu badge-dot warning"> </span>}
                            {stateMenuData.boardOverdue > 0 && <span className="badge badge-menu badge-dot danger"> </span>}
                        </NavLink>
                    </li>
                    {idRole !== 2 && (
                        <>
                            <li className="metismenu-item">
                                <a className="metismenu-link has-active-child" href="#" onClick={() => { setMenuParamOpen(!menuParamOpen); }}>
                                    <i className="metismenu-icon"><FontAwesomeIcon icon={faDatabase} /></i>
                                    Справочники
                                    <i className="metismenu-state-icon pe-7s-angle-down caret-left"></i>
                                </a>
                                <ul className={menuParamOpen === true ? "metismenu-container visible" : "metismenu-container"}>
                                    <li className="metismenu-item">
                                        <NavLink className="metismenu-link" to="/lk/ref/param" onClick={() => handlerClickMenu()}>
                                            Параметры
                                        </NavLink>
                                    </li>
                                    <li className="metismenu-item">
                                        <NavLink className="metismenu-link" to="/lk/ref/label" onClick={() => handlerClickMenu()}>
                                            Метки
                                        </NavLink>
                                    </li>
                                </ul>
                            </li>
                            <li className="metismenu-item" onClick={() => handlerClickMenu()}>
                                <NavLink className="metismenu-link" to="user">
                                    <i className="metismenu-icon">
                                        <FontAwesomeIcon icon={faUsers} />
                                    </i>
                                    Пользователи
                                </NavLink>
                            </li>
                        </>
                    )}
                </ul>
            </div>
            <h5 className="app-sidebar__heading">Глобальное меню</h5>
            <div className="metismenu vertical-nav-menu">
                <ul className="metismenu-container">
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="company" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faBuilding} />
                            </i>
                            Компании
                            {stateCompanyList.listInRequest !== null &&
                                stateCompanyList.listInRequest.length > 0 &&
                                (<span className="badge badge-menu badge-dot warning"> </span>)
                            }

                        </NavLink>
                    </li>
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="setting" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faGear} />
                            </i>
                            Настройки
                            {stateSetting.user !== null && stateSetting.user.Is_Password === false && <span className="badge badge-menu badge-dot danger"> </span>}
                        </NavLink>
                    </li>
                    <li className="metismenu-item">
                        <NavLink className="metismenu-link" to="support" onClick={() => handlerClickMenu()}>
                            <i className="metismenu-icon">
                                <FontAwesomeIcon icon={faEnvelope} />
                            </i>
                            Поддержка
                            {stateTicket.unreadList.filter(a => a.Count_Message > 0).length > 0 && (<span className="badge badge-menu badge-dot warning"> </span>)}
                        </NavLink>
                    </li>
                </ul>
            </div>

            {/*stateMenu.enableClosedSidebar === false && (
                stateSubscription.info !== null &&
                (
                    <>
                        {stateSubscription.info.Status_Pay === 0 &&
                            <div className='vertical-nav-menu-info'>
                                <Link to="/lk/billing">
                                    <div className='red' style={{ cursor: 'pointer' }}>Подписка закончилась</div>
                                </Link>

                            </div>
                        }
                        {stateSubscription.info.Status_Pay === 2 &&
                            <div className='vertical-nav-menu-info'>
                                <Link to="/lk/billing"> <div className='red' style={{ cursor: 'pointer' }}>Активировать пробный период 7 дней</div></Link>
                            </div>
                        }
                    </>
                )
            )*/}
        </Fragment>
    );
}

export default VerticalNavWrapper;